import React from "react";
import { useInView } from "../../hooks/useInView";
import upArrow from "../../assets/chev-lrs.svg";
import downArrow from "../../assets/chev-lrs.png";

export type InfoCardData = {
  image: string;
  title: string;
  description: string;
  characteristics?: string[];
  applications?: string;
  direction?: "imageLeft" | "imageRight";
};

interface AccordionItemProps {
  item: InfoCardData;
  isOpen: boolean;
  onClick: () => void;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ item, isOpen, onClick }) => {
  const [ref] = useInView<HTMLDivElement>({ threshold: 0.2 });

  return (
    <div className="border-b border-[#DDE4EB]">
      {/* Toggle Header */}
      <button
        onClick={onClick}
        className={`w-full flex justify-between items-center py-4 pt-5 px-2 sm:px-4 text-left transition-colors duration-300 ${
          isOpen ? " font-bold" : ""
        }`}
      >
        <span className="font-utility font-medium text-[24px] leading-[120%] tracking-normal align-middle capitalize text-[#011621]">
          {item.title}
        </span>
        <span
          className={`text-[20px] transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <img
            src={isOpen ? upArrow : downArrow}
            alt={isOpen ? "Up arrow" : "Down arrow"}
            className="inline w-[30px] h-[30px]"
          />
        </span>
      </button>

      {/* Expandable Content */}
      <div
        ref={ref}
        className={`bg-[#F5F7FA] px-[14px]  sm:px-6 md:px-10 overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-[1000px] opacity-100 pt-0 pb-8" : "max-h-0 opacity-0 pt-0 pb-0"
        }`}
        style={{ transitionProperty: "max-height, opacity, padding" }}
      >
        {isOpen && (
          <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-[32px] items-start">
            {/* Image */}
            <div>
              <img
                src={item.image}
                alt={item.title}
                className="w-full max-w-full h-auto md:w-[852px] md:h-[567px] object-cover "
              />
            </div>

            {/* Content */}
            <div className="text-[#0A1E2D]">
              

             

              {/* Description */}
              <div className="mb-6">
                <h4 className="text-[#4F7286] text-[18px] md:text-[20px] mb-1">Description:</h4>
                <p className="text-[#033652] text-[18px] md:text-[20px] leading-[150%]">
                  {item.description}
                </p>
              </div>

              {/* Characteristics */}
              {item.characteristics && (
                <div className="mb-6">
                  <h4 className="text-[#4F7286] text-[18px] md:text-[20px] mb-1">Characteristics:</h4>
                  <ul className="text-[#033652] text-[18px] md:text-[20px] leading-[150%] list-disc list-inside space-y-1">
                    {item.characteristics.map((c, i) => (
                      <li key={i}>{c}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Applications */}
              {item.applications && (
                <div>
                  <h4 className="text-[#4F7286] text-[18px] md:text-[20px] mb-1">Applications:</h4>
                  <p className="text-[#033652] text-[18px] md:text-[20px] leading-[150%]">
                    {item.applications}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccordionItem;
